module.exports = __webpack_public_path__ + "static/img/2_2_1_1.f14bbcf7.jpg";